import { Box, Button, Card, styled } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import FlexBox from 'components/flexbox/FlexBox';
import AddEmployeeModal from 'page-sections/data-table/dataTableUserOperator/AddEmployeeModal';
import DataTable from 'page-sections/data-table/dataTableUserOperator/DataTable';
import { useEffect, useState } from 'react';
// import { useTranslation } from "react-i18next";
import axiosInstance from 'utils/axios';
import ExportExcel from 'utils/ExportExcel';
import { searchByName } from 'utils/utils';

const ButtonWrapper = styled(FlexBox)(({ theme }) => ({
    [theme.breakpoints.down(500)]: {
        marginTop: 10,
        width: '100%',
        flexDirection: 'column-reverse',
        '& > .MuiBox-root': {
            width: '100%',
            margin: '10px 0',
            alignItems: 'center',
            flexDirection: 'column',
        },
        '& .MuiButton-root': {
            minWidth: '100%',
        },
    },
}));

const UserListAdmin = () => {
    // const {
    //   t
    // } = useTranslation();
    const [tableData, setTableData] = useState([]);
    const [hasFilter, setHasFilter] = useState('');
    const [clearFilter, setClearFilter] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [dataToEdit, setDataToEdit] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [exportData, setExportData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [filteredItem, setFilteredItem] = useState([]);

    const handleRowSelect = (rowArr) => setSelectedRows(rowArr);

    const handleClearFilter = () => {
        setClearFilter('...');
        setTimeout(() => {
            setClearFilter('');
        }, 50);
    };

    const ids = selectedRows.map((item) => item.original.id);

    const handleDelete = async () => {
        for (let index = 0; index < ids.length; index++) {
            await axiosInstance
                .delete(`api/users/${ids[index]}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'accessToken',
                        )}`,
                    },
                })
                .then((res) => console.log(res))
                .catch((err) => console.log(err));
        }

        const filteredData = tableData.filter((item) => !ids.includes(item.id));
        setFilteredItem(filteredData);
    }; // search input

    const excludeData = [
        'Test Payment Bhavana',
        'test',
        'Operator',
        'tes',
        'syafiq anshori',
        'Syafiq Anshori',
        'Syafiq Operator',
        'Aufal',
        'Hatdi',
        'Testgroupinaacc@gmail.com',
        'test@gmail.com',
    ];
    const handleEdit = (data) => {
        setDataToEdit(data);
        setOpenModal(true);
    };
    const getData = async () => {
        setExportData([]);
        axiosInstance
            .get('/api/users', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'accessToken',
                    )}`,
                },
            })
            .then(({ data }) => {
                setTableData(data);
                setFilteredItem(data);
                const filteredData = data
                    .filter((item) => !excludeData.includes(item.full_name))
                    .map((item, index) => ({
                        No: index + 1,
                        Name: item.full_name,
                        Profession: item.profession.name,
                        Phone: item.phone_number,
                        Email: item.email,
                        Institution: item.institution,
                        City: item.city,
                        Registration_Date: item.created_at,
                    }));
                setExportData(filteredData);
            })
            .catch((error) => console.log(error));
        const result = searchByName(tableData, searchValue);
        setFilteredItem(result);
    };
    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);
    const handleUserDataUpdate = async () => {
        // Fetch updated data or perform any necessary update
        await getData();
    };
    return (
        <Box pt={2} pb={4}>
            <FlexBetween flexWrap="wrap">
                {/* <SearchInput bordered={false} placeholder="Find Participant" onChange={e => setSearchValue(e.target.value)} /> */}

                <ButtonWrapper alignItems="center">
                    {/* {selectedRows.length > 0 && <FlexBox alignItems="center" mr={2}>
                <H6 mr={1}>{selectedRows.length} Selected</H6>
                <Button size="small" color="error" variant="contained" onClick={handleDelete} sx={{
              color: "common.white"
            }}>
                  Delete Selected
                </Button>
              </FlexBox>} */}
                    <ExportExcel
                        excelData={exportData}
                        fileName={'Data Participant'}
                    />

                    {!!hasFilter && (
                        <FlexBox alignItems="center" ml={2}>
                            <Button
                                size="small"
                                color="error"
                                variant="contained"
                                sx={{
                                    color: 'common.white',
                                }}
                                onClick={handleClearFilter}
                            >
                                Clear filter
                            </Button>
                        </FlexBox>
                    )}
                </ButtonWrapper>
            </FlexBetween>

            <AddEmployeeModal
                onSubmissionSuccess={handleUserDataUpdate}
                edit={true}
                data={dataToEdit}
                open={openModal}
                onClose={() => setOpenModal(false)}
            />

            <Card
                sx={{
                    marginTop: 3,
                }}
            >
                <DataTable
                    data={filteredItem}
                    handleEdit={handleEdit}
                    clearFilter={clearFilter}
                    handleRowSelect={handleRowSelect}
                    onFilterChange={(filters) => setHasFilter(filters.length)}
                />
            </Card>
        </Box>
    );
};

export default UserListAdmin;
